import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTreeItem } from "@mui/x-tree-view/TreeItem";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const DEFAULT_COLLAPSE_ICON = _jsx(ExpandMoreIcon, {});
const DEFAULT_EXPAND_ICON = _jsx(ChevronRightIcon, {});
const TreeItemLabel = ({ node, titleRender, onLazyLoad, loading, collapseIcon = DEFAULT_COLLAPSE_ICON, expandIcon = DEFAULT_EXPAND_ICON, }) => {
    const { expanded, handleExpansion, preventSelection, handleSelection } = useTreeItem(node.key);
    const hasLazyLoad = typeof node.children != "undefined" && node.children.length == 0;
    const handleExpansionClick = async (event) => {
        if (loading) {
            return;
        }
        if (hasLazyLoad) {
            onLazyLoad && onLazyLoad();
        }
        else {
            handleExpansion(event);
        }
        event.stopPropagation();
        event.preventDefault();
        preventSelection(event);
    };
    useEffect(() => {
        if (expanded && hasLazyLoad) {
            onLazyLoad && onLazyLoad();
        }
    }, [expanded]);
    const hasChildren = typeof node.children != "undefined";
    const icon = hasChildren ? (_jsxs("div", { onClick: handleExpansionClick, className: "MuiTreeItem-iconContainer", children: [expanded && collapseIcon, !expanded && expandIcon] })) : (_jsx("div", { className: "MuiTreeItem-iconContainer" }));
    return (_jsxs(_Fragment, { children: [loading && (_jsx("div", { className: "MuiTreeItem-iconContainer", children: _jsx(CircularProgress, { color: "inherit", size: 12 }) })), !loading && icon, _jsx("div", { className: "MuiTreeItem-label", children: titleRender ? titleRender(node) : node.title })] }));
};
export default TreeItemLabel;
